import { getRoleTypeNameFromKey } from "../";
import { GgMeType } from "@/types";

type UserWithCurrentRoleKey =
  Pick<GgMeType, "currentRoleKey"> | null | undefined;

export const getRoleTypeNameFromUser = (user: UserWithCurrentRoleKey) => {
  let returnString = "";
  if (user?.currentRoleKey) {
    returnString = getRoleTypeNameFromKey(user?.currentRoleKey);
  }
  return returnString;
};
